<template>
  <div class="fixWidth container-fluid">
   <v-dialog v-model="formDialogStatus" max-width="1000px" persistent>
    <formDialog
    :dialogStatus.sync="formDialogStatus"
    :editedData="editedItem"
    :indexEdited.sync="editedIndex"
    ></formDialog>
  </v-dialog>
  <v-dialog v-model="deleteDialogStatus" max-width="600px">
    <deleteDialog
    v-on:changeTitle="updateTitleData($event)"
    v-on:changeStat="closeDelDialog($event)"
    ></deleteDialog>
  </v-dialog>
  <snackbar :snacksProp="snackBar" />
  <!-- {{getAssignPermissionItem}} -->
  <template>
    <v-card>
      <v-container class="fixWidth">
        <v-row>
          <v-col cols="12" sm="6" md="3"></v-col>
          <v-col cols="12" sm="6" md="6">
            <!-- {{getRoleItem}} -->
            <v-autocomplete
            name="Title"
            item-text="name"
            item-value="id"
            v-model="roleSchema.role_id"
            chips
            clearable
            @change="searchPermission()"
            :items="getRoleItem"
            label="Role"
            >
            <template v-slot:selection="data">
              <v-chip
              color="grey lighten-4"
              :input-value="data.selected"
              >
              <span class="subheading">{{
                data.item.name
              }}</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      

    </v-row>
  </v-container>
</v-card>


  <v-card
  class="mx-auto"
  
  >


  
    <v-row>
      <v-col cols="12" sm="6" md="3"> 
      </v-col>
      <!-- {{searchParam.parent_id}} -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
        name="Title"
        item-text="name"
        item-value="id"
        v-model="searchParam.permission_id"
        chips
        clearable
        :items="getPermissionItem"
        label="Permission Parent"
        >
        <template v-slot:selection="data">
          <v-chip
          color="grey lighten-4"
          :input-value="data.selected"
          >
          <span class="subheading">{{
            data.item.name
          }}</span>
        </v-chip>
      </template>
    </v-autocomplete>
  </v-col>
  <v-col cols="12" sm="6" md="3">  <v-card-actions>
    <v-layout justify-center>
      <v-btn
      class="mx-2"
      fab
      dark
      small
      color="primary"
      @click.stop.prevent="searchPermission()"
      >
      <v-icon dark>
        mdi-magnify
      </v-icon>
    </v-btn>
    <v-btn
    class="mx-2"
    fab
    dark
    small
    color="red"
    @click="cancelPermission()"
    >
    <v-icon dark>
      mdi-close
    </v-icon>
  </v-btn>
  
  <span></span>
</v-layout>
</v-card-actions></v-col>

</v-row>
<v-row dense>
  <v-col
  >
  <v-card>  
    <!-- {{getAssignPermissionItem}}     -->
    <v-data-table
    :headers="headers"
    :items="getAssignPermissionItem"
    :server-items-length="totalItems"
    :options.sync="pagination"
    :footer-props="pagination.rowsPerPageItems"
    :loading="loading"
    hide-default-footer
    >
    <template v-slot:item.parentName="{ item }">

      <tr>{{item.permission_name}}</tr>

    </template>
     <template v-slot:item.children="{ item }">
      <v-data-table
    :headers="headersChild"
    :items="item.child"
    :server-items-length="totalItems"
    :options.sync="pagination"
    :footer-props="pagination.rowsPerPageItems"
    :loading="loading"
    hide-default-footer
    >
    <template v-slot:item.childName="{ item }">
      <td>{{item.permission_name}}</td>
    </template>
    <!-- <template v-slot:item.actionChild="{ item }">
      <td>{{item.permission_name}}</td>
    </template> -->
      <template v-slot:item.selectAllChild="{ item }">
    <v-row>
      <v-col
      cols="12"
      sm="4"
      md="4"
      >    
      <!-- {{item.all}} -->
      <v-checkbox
      v-model="item.all"
      label="All"
      @change="itemAllSelected(item)"
      value="true"
      hide-details
   
      ></v-checkbox>        
    </v-col>
    

  </v-row>
</template>
<template v-slot:item.actionsChild="{ item }">
  <v-row>
    <v-col
    cols="12"
    sm="4"
    md="4"
    >
    
    <v-checkbox
    v-model="item.list"
    label="List"

    value="1"
    hide-details
    
    ></v-checkbox>
    <v-checkbox
    v-model="item.add"
    label="Add"
    
    value="1"
    hide-details
    ></v-checkbox>

  </v-col>
  <v-col
  cols="12"
  sm="4"
  md="4"
  >
  <v-checkbox
  v-model="item.edit"
  label="Edit"
  
  value="1"
  hide-details
  ></v-checkbox>
  <v-checkbox
  v-model="item.approve"
  label="Approve"
  
  value="1"
  hide-details
  ></v-checkbox>

</v-col>
<v-col
cols="12"
sm="4"
md="4"
>
<v-checkbox
v-model="item.delete"
label="Delete"

value="1"
hide-details
></v-checkbox>
<v-checkbox
v-model="item.get"
label="Get"

value="1"
hide-details
></v-checkbox>

</v-col>

</v-row>
</template>
  </v-data-table>
   <!--    <tr v-for="child in item.child">{{child.permission_name}}</tr> -->
    </template>
    <template v-slot:top>
      <v-toolbar
      flat
      >
      <v-toolbar-title>Role Permission List</v-toolbar-title>
      
      <v-divider
      class="mx-4"
      inset
      vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="upgradeInfo"
      >Update</v-btn>


    </v-toolbar>

  </template>
  

  
<template v-slot:no-data>
 
  No data available

</template>
</v-data-table>



</v-card>
</v-col>
</v-row>

</v-card>

<v-card>

</v-card>

</template>

</div>
</template>
<script>
import formDialog from "@/components/districtNew/districtNewForm.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import snackbar from "@/components/utils/snackbar.vue";

export default {
  components: {
    formDialog,
    deleteDialog,
    snackbar
  },
  data() {
    return {

      pagination: {
        itemsPerPage: 10,
        rowsPerPageItems: {'items-per-page-options': [5,10,25,100,200]}
      },
      snackbarMessage:"",
      totalItems:null,
      searchString:"",
      editedItem:{},
      desserts: [
          {
            name: 'Frozen Yogurt',
            calories: 159,
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
          },
          {
            name: 'Eclair',
            calories: 262,
          },
          {
            name: 'Cupcake',
            calories: 305,
          },
          ],
      editedIndex: -1,
      loading: false,
      title : "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus:false,
      deleteId:{},
      currentItem: {},
      divisionList: [],
      searchString: '',
      searchParam: {},
      roleSchema:{},
      snackBar: {
        control: false,

        multiline: true,
        text: {

          message: '',
        },
      },
      allSelectAction:false,
      // shanita

      permissionAssignSchema:{
        role_id: "",
        permissions: [           
        ]
      },
      headers: [

      { text: "Parent Name", value: "parentName", sortable: false },
      { text: "Child", value: "children", sortable: false },
      // { text: "All Select", value: "selectAll", sortable: false },
      // { text: "Actions", value: "actions", sortable: false },
    ],
    headersChild:[

      { text: "Child", value: "childName", sortable: false },
      // { text: "Actions", value: "actionChild", sortable: false },
      { text: "All Select", value: "selectAllChild", sortable: false },
      { text: "Actions", value: "actionsChild", sortable: false },
      ]

    };
  },
  created() {
    this.$store.dispatch("callPermissionData", {
      page: 1,
      size: -1
    });
    this.$store.dispatch("callRoleData", {
      page: 1,
      size: -1
    });
    

  },
  mounted() {
    // this.$validator.localize("en", this.dictionary);
    
  },
  computed: {

    getAssignPermissionItem() {
      return this.$store.getters.getAssignPermissionItem;
    },
    getRoleItem() {
      return this.$store.getters.getRoleItem;
    },
    getPermissionItem() {
      return this.$store.getters.getPermissionItem;
    },
    getLoggedInStatus() {
      return this.$store.getters.getLoggedIn;
    },

    getResponseMessage(){
      return this.$store.getters.getResponseMessage;
    },
    getErrorMessage(state){
      return this.$store.getters.getErrorMessage;
    },

  },
  watch: {
    getTitle(val){

      if(val == "confirmed"){
        this.deleteItem();
      }
    },
    // pagination() {

    //   this.searchPermission();
    // },
    getResponseMessage(val){
     //  console.log("val get response",val);
      
      this.snackBar.text.message = val.message;
      this.snackBar.control = true;

    },
    getErrorMessage(val){
     //  console.log("val asada",val.message);
      let myObject = val.message;
      for (const [key, value] of Object.entries(myObject)) {

       this.snackBar.text.message = value[0];
       this.snackBar.control = true;
     }
   }



 },

 methods: {
  searchPermission() {
    if(this.roleSchema.role_id){
      this.loading = true;
      this.searchString = "";
      if (this.searchParam.permission_id) {
        this.searchString = `permission_id=${this.searchParam.permission_id}`;
      }
      
      encodeURIComponent(this.searchString);
      this.$store
      .dispatch("callAssignPermissionData", {
        role_id : this.roleSchema.role_id,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        search: this.searchString,
      })
      .then((data) => {
        this.loading = false;
       //  console.log("data",data)
        this.totalItems = this.$store.getters.getDataCount;
        this.getAssignPermissionItem.forEach((obj) => {
          let childArr = obj.child;
          childArr.forEach((obj) => {
            if(obj.add == "1" && obj.edit == "1" && obj.get == "1" && obj.list == "1" && obj.delete == "1" && obj.approve == "1")
         {
          //  console.log("done");
           obj.all = "true";
          //  console.log(obj.all);
         }
            });
         
         


       });
      });
    }
    
    
  },

  


  upgradeInfo(){
    var self = this;
    this.permissionAssignSchema.role_id = this.roleSchema.role_id;
    this.permissionAssignSchema.permissions = [];
    this.getAssignPermissionItem.forEach((obj) => {
      let childObjArr = obj.child;
     //  console.log("childObjArr",childObjArr);
      childObjArr.forEach((obj) => {
          var permission_id = obj.permission_id;
      var add = obj.add;
      var edit = obj.edit;
      var get = obj.get;
      var list = obj.list;        
      var deleteItem = obj.delete;
      var approve = obj.approve;
      var parent_id =  obj.parent_id;  
      this.permissionAssignSchema.permissions.push({
        "permission_id":permission_id,
        "add":add,
        "edit":edit,
        "get":get,
        "list":list,
        "delete":deleteItem,
        "approve":approve,
        "parent_id":parent_id
      });

      });
      // var permission_id = obj.permission_id;
      // var add = obj.add;
      // var edit = obj.edit;
      // var get = obj.get;
      // var list = obj.list;        
      // var deleteItem = obj.delete;
      // var approve = obj.approve;
      // var parent_id =  obj.parent_id;  
      // this.permissionAssignSchema.permissions.push({
      //   "permission_id":permission_id,
      //   "add":add,
      //   "edit":edit,
      //   "get":get,
      //   "list":list,
      //   "delete":deleteItem,
      //   "approve":approve,
      //   "parent_id":parent_id
      // });
      
      
    });
    let item = this.permissionAssignSchema;
   //  console.log("item permissionAssignSchema",item);
    this.$store
    .dispatch("updateRolePermissionData", item)
    .then(function (data) {
      self.$store.dispatch("callRolePermissionMenuData", {
        page: 1,
        size: -1,
      });
    })
    .catch(function (error) {
     //  console.log(error);
      
    });
  },




  cancelPermission(){
   this.searchParam = {};
   this.roleSchema={};
 },
 itemAllSelected(val){
 //  console.log("caaaaaaaa",val.all);
  if(val.all == null){
    val.list =  "0";
    val.add =  "0";
    val.delete =  "0";
    val.edit =  "0";
    val.approve =  "0";
    val.get = "0";
  }
  if(val.all == "true"){
    val.list =  "1";
    val.add =  "1";
    val.delete =  "1";
    val.edit =  "1";
    val.approve =  "1";
    val.get = "1";
  }
  return val;
}

},
};
</script>
<style>
.v-input.v-input--hide-details.v-input--is-label-active.v-input--is-dirty.theme--light.v-input--selection-controls.v-input--checkbox.primary--text {
  margin-top: 5px;
}
label.v-label.theme--light {
  margin: 0;
}
.v-input.v-input--hide-details.theme--light.v-input--selection-controls.v-input--checkbox {
  margin-top: 5px;
}
</style>
